import Table from "components/DataTable/Table";
import RefreshButton from "components/RefreshButton/RefreshButton";
import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import useWorkOrder from "features/Contexts/WorkOrderContext";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import AdvanceFormLayout from "./AdvanceSearch/AdvanceFormLayout";
import CustomerAdd from "./CustomerAdd";

function Customers() {
  const user = useSelector((state) => state.user?.userInfo);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { customerContextData } = useWorkOrder();
  // const { advanceSearchParams, setAdvanceSearchParams } = useCustomer();

  /*   All States
   ********************************************* */
  const [allCustomersData, setAllCustomersData] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [locations, setLocations] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState({
    locationName: "All locations",
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [advanceSearchModal, setAdvanceSearchModal] = useState(false);

  /*   All Function
   ********************************************* */
  const getAllCustomersData = async (_page, _filterBy, query, location) => {
    try {
      setLoading(true);

      let body = {
        page: _page,
        filterBy: _filterBy,
        query,
      };

      // check for sort and order in searchParams
      let sort = searchParams.get("sort");
      let order = searchParams.get("order");
      if (sort && order) {
        body.sort = sort;
        body.order = order;
      }

      if (location !== "all" && location) {
        body.location = location;
      }

      const { data } = await API.post("/customers", body, {
        headers: authHeader(),
      });

      setAllCustomersData(data?.result);
      setTotalPages(data?.pages);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    }
  };

  const getAllLocations = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/locations", { headers: authHeader() });
      setLocations(data);
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
    }
  };

  /*   Table Functions
   ********************************************* */
  const btn1 = () => (
    <div>
      {(user?.permissions?.includes("customer_add") ||
        user?.roles === "admin") && (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Dropdown className="">
            <Dropdown.Toggle
              variant="outline-info"
              className="px-1 bg-primary btn text-dark bg-opacity-10 border border-primary rounded-end rounded-start"
              id="dropdown-basic2"
            >
              {selectedLocation?.locationName
                ? selectedLocation?.locationName
                : "No Location"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={(e) => {
                  setSelectedLocation({ locationName: "All locations" });
                  updateSearchParams("location", "all");
                }}
              >
                All
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  setSelectedLocation({ locationName: "No Location" });
                  updateSearchParams("location", "no-location");
                }}
              >
                No Location
              </Dropdown.Item>
              {locations?.map((item) => (
                <Dropdown.Item
                  key={item.id}
                  onClick={(e) => {
                    setSelectedLocation(item);
                    updateSearchParams("location", item?.id);
                  }}
                >
                  {item?.locationName}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <RefreshButton
            className="btn px-2 btn-outline-primary"
            onClick={() =>
              getAllCustomersData(
                searchParams.get("page") || 1,
                searchParams.get("filterBy"),
                searchParams.get("query"),
                searchParams.get("location"),
              )
            }
          />

          <button
            onClick={() => setAdvanceSearchModal(true)}
            type="button"
            className="btn px-2 btn-success"
          >
            Find
          </button>

          <button
            onClick={() => setShowAddModal(true)}
            type="button"
            className="btn px-2 btn-primary"
          >
            Add Customer
          </button>
        </div>
      )}
    </div>
  );

  // Clear Advance Search
  const btnAS = () => (
    <>
      <button
        className="btn btn-danger  ms-1"
        onClick={(e) => {
          setSearchResult(null);
          // setAdvanceSearchParams(null);
        }}
      >
        Clear Advance Search
      </button>
    </>
  );

  const table_head = [
    { name: "C-ID", value: "customerId" },
    { name: "Customer Name", value: "customerName" },
    { name: "Inside Sales Person", value: "salesManager" },
    { name: "Outside Sales Person", value: "salesPersonId" },
    { name: "Payment Term", value: "paymentTermsId" },
    { name: "Po Required", value: "poRequired" },
    { name: "State", value: "addressState" },
    { name: "Location", value: "locationId" },
    { name: "Actions", value: "Actions" },
  ];

  const table_S_head = [
    "C-ID",
    "Customer Name",
    "Inside Sales Person",
    "Outside Sales Person",
    "Payment Term",
    "Po Required",
    "State",
    "Location",
    "Actions",
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-1 align-middle">C-{item?.customerId}</td>
      <td
        className="py-1 align-middle"
        onDoubleClick={() => {
          navigate(
            `/customer/details/${item?.customerId}?${searchParams.toString()}`,
          );
        }}
      >
        {item?.customerName}
      </td>
      <td className="py-1 align-middle">{`${item?.user?.firstName || ""} ${item?.user?.lastName || ""}`}</td>
      <td className="py-1 align-middle">{item?.salesPerson?.name || ""}</td>
      <td className="py-1 align-middle">{item?.paymentTerm?.termName || ""}</td>
      <td className="py-1 align-middle">{item?.poRequired ? "Yes" : "No"}</td>
      <td className="py-1 align-middle">{item?.addressState}</td>
      <td className="py-1 align-middle">{item?.location?.name || ""}</td>
      <td className="table-action py-1 align-middle">
        <button
          onClick={() => {
            navigate(
              `/customer/details/${item?.customerId}?${searchParams.toString()}`,
            );
          }}
          className={`btn btn-sm bg-success text-white mx-2 `}
        >
          Details
        </button>
      </td>
    </tr>
  );

  const updateSearchParams = (key, value) => {
    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
    setSearchParams(searchParams);
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);

    return params.toString();
  };

  /*   All UseEffect
   ********************************************* */

  useEffect(() => {
    if (!customerContextData) {
      let timeout = setTimeout(() => {
        getAllLocations();
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    let page = searchParams.get("page");
    if (!page) {
      updateSearchParams("page", 1);
    }
    let _page = page ? page : 1;

    let _filterBy = searchParams.get("filterBy");
    let query = searchParams.get("query");
    let location = searchParams.get("location");

    if (location && locations) {
      if (location === "all" || location === null) {
        setSelectedLocation({ locationName: "All locations" });
      } else {
        let _selectedLocation = locations.find(
          (item) => item.id === parseInt(location),
        );
        setSelectedLocation(_selectedLocation);
      }

      let tid = setTimeout(() => {
        getAllCustomersData(_page, _filterBy, query, location);
      }, 100);
      return () => {
        clearTimeout(tid);
      };
    } else {
      if (user && user?.defaultLocation && locations) {
        let _selectedLocation = locations?.find(
          (item) => item.id === user.defaultLocation,
        );
        setSelectedLocation(_selectedLocation);
        updateSearchParams("location", _selectedLocation?.id);
      } else {
        updateSearchParams("location", "all");
        setSelectedLocation("no-default-location");
      }
    }
  }, [searchParams, user, locations]);

  if (!allCustomersData) return <Spinner />;
  return (
    <div className="row">
      {loading && <Spinner />}

      <div className="col-12">
        <div className="d-flex ">
          {/*    Table Card
           ********************************************* */}
          <div
            className=" pb-2 flex-grow-1 rounded d-flex"
            style={{ marginLeft: 260 }}
          >
            {allCustomersData && !searchResult && (
              <>
                <div className=" px-3 py-2 pb-2 horizontal-scrollable py-4 d-flex flex-column flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h3 className="m-0">Customers</h3>
                    </div>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="me-1">{btn1()}</div>
                      <SearchComp
                        setLoading={setLoading}
                        apiPath={`/customer/?${getSearchParamsWithoutGivenKey(
                          "query",
                        )}&`}
                      />
                    </div>
                  </div>

                  <TableOnly
                    table_head={table_head}
                    table_body={table_body}
                    table_data={allCustomersData}
                  />

                  <Pagination
                    totalPages={totalPages}
                    apiPath={`/customer/${
                      searchParams.toString()
                        ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                        : "?"
                    }page=`}
                    currPage={parseInt(searchParams.get("page")) || 1}
                  />
                </div>
              </>
            )}

            {searchResult && (
              <>
                <div className=" px-3 py-2 pb-2 horizontal-scrollable py-4 d-flex flex-column flex-grow-1">
                  <Table
                    btn1={btnAS}
                    table_head={table_S_head}
                    table_body={table_body}
                    table_data={searchResult}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/*   Add Modal
       ********************************************* */}
      <CustomerAdd
        customersData={allCustomersData}
        showAddModal={showAddModal}
        setShowAddModal={setShowAddModal}
      />

      {/*   Advance Customer Search
       ********************************************* */}
      <Modal
        size="xl"
        contentClassName="bg-transparent"
        show={advanceSearchModal}
        onHide={() => setAdvanceSearchModal(false)}
      >
        <Modal.Body
          className="bg-light custom-shadow-sm p-3"
          style={{ borderRadius: 15 }}
        >
          <AdvanceFormLayout
            showModal={setAdvanceSearchModal}
            setSearchResult={setSearchResult}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Customers;
